import { Trans } from "@lingui/macro";
import React, { useEffect, useRef, useState } from "react";
import { InputText } from "components/UI/InputText/InputText";
import { useInputChange } from "hooks/useInputChange";
import { Button } from "components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  dOrdersDeleteProductFromCartItemAC,
  dOrdersSetDetailProductAC,
} from "model/dashboardOrders/dOrdersActionCreators";
import { IdOrdersState } from "model/dashboardOrders/dOrdersReducer";

// Type
export type typePopupChangePrice = {
  setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

const templateMarkLabel1 = /^01.{14}21.+(91|92|93)/;
const templateMarkLabel2 = /^01.{14}21.+/;

// Component
export const PopupDeleteMarkedProduct: React.FC<typePopupChangePrice> = ({
  setOpenPopup,
}) => {
  const dispatch = useDispatch();
  const refInput = useRef(null);

  const product = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.detailProduct,
  );
  const { value: labelValue, changeValueHandler: labelValueHandler } =
    useInputChange("");

  useEffect(() => {
    if (refInput?.current) {
      // @ts-ignore
      refInput?.current?.focus();
    }
  }, []);

  //did unmount
  useEffect(() => {
    return () => {
      dispatch(dOrdersSetDetailProductAC(undefined));
    };
    // eslint-disable-next-line
  }, []);

  // // const product = useSelector((state: {  dOrders: IdOrdersState }) => state.dOrders.detailProduct)
  // const currentOrder = useSelector((state: { dOrders: IdOrdersState }) => state.dOrders.newOrder)
  // const selectedStore = useSelector((state: { dOrders: IdOrdersState }) => state.dOrders.selectedStore)

  //validate
  const [validationObject, setValidationObject] = useState({
    validMarkLabel: true,
    requiredMarkedLabel: true,
  });
  useEffect(() => {
    if (labelValue.trim()) {
      setValidationObject(() => {
        return {
          requiredMarkedLabel: true,
          validMarkLabel: true,
        };
      });
    } else {
      setValidationObject(() => {
        return {
          validMarkLabel: true,
          requiredMarkedLabel: false,
        };
      });
    }
  }, [labelValue]);

  const validationMarkLabelHelper = (markLabel: string) => {
    const temp1 = markLabel.match(templateMarkLabel1);
    const temp2 = markLabel.match(templateMarkLabel2);
    if (temp1) {
      return temp1[0].substring(2, 16)
        ? temp1[0].substring(0, temp1[0].length - 2)
        : null;
    }
    if (temp2) {
      return temp2[0].substring(2, 16) ? temp2[0] : null;
    }
    return markLabel.substring(0, 14)
      ? markLabel.length > 63
        ? markLabel.substring(0, 21)
        : markLabel
      : markLabel;
  };

  const onApplyClickHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // @ts-ignore
    if (validationMarkLabelHelper(labelValue.trim()) === product!.markLabel) {
      // @ts-ignore
      dispatch(dOrdersDeleteProductFromCartItemAC(product!.index));
      setOpenPopup(false);
    } else {
      setValidationObject({
        validMarkLabel: false,
        requiredMarkedLabel: true,
      });
    }
  };

  return (
    <div className="flex flex-col gap-2 sm:gap-4">
      {product && (
        <form
          onSubmit={(event) => onApplyClickHandler(event)}
          className="flex flex-col gap-4"
        >
          <div>
            <InputText
              id="deletingMarkLabel"
              label={<Trans>Mark label</Trans>}
              type="text"
              value={labelValue}
              onChange={labelValueHandler}
              required={true}
              errorMessage={
                validationObject.requiredMarkedLabel ? (
                  validationObject.validMarkLabel ? undefined : (
                    <Trans>Marking don't matched for deleting product!</Trans>
                  )
                ) : (
                  <Trans>Required field</Trans>
                )
              }
              autoFocus={true}
              inputRef={refInput}
            />
          </div>

          <div className={"text-xs text-center whitespace-wrap text-gray-500"}>
            <Trans>Enter the marking for deleting product</Trans>
          </div>
          <Button
            type="submit"
            label={<Trans>Apply</Trans>}
            disabled={
              !validationObject.validMarkLabel ||
              !validationObject.requiredMarkedLabel
            }
          />
        </form>
      )}
    </div>
  );
};
